import { useEffect, useState } from "react";
import useDefaultCRUDHandlers from "../../../../hooks/useDefaultCRUDHandlers";
import { ILead } from "../../../../models/Lead";
import useLeads from "../../../../data/useLeads";
import ContactFromId from "../../../contacts/ContactFromId";
import formatDateTime from "../../../../utils/formatDateTime";
import { DateTime } from "luxon";

export default function LeadsTableCallCount({ lead }: { lead: ILead }) {
  const { updateCallCount } = useLeads(true, "LeadsTableCallCount");
  const { saveHandlers } = useDefaultCRUDHandlers("Leads");
  const [currentCallCount, setCurrentCallCount] = useState<number>(lead.callCount);
  const [callCountUpdatedOn, setCallCountUpdatedOn] = useState<string | null>(lead.callCountUpdatedOn);
  const [callCountUpdatedBy, setCallCountUpdatedBy] = useState<string | null>(lead.callCountUpdatedBy);

  useEffect(() => {
    setCurrentCallCount(lead.callCount);
    setCallCountUpdatedOn(lead.callCountUpdatedOn);
    setCallCountUpdatedBy(lead.callCountUpdatedBy);
  }, [lead.callCount, lead.callCountUpdatedOn, lead.callCountUpdatedBy]);

  const handleCallListClick = (e: any, isPlus: boolean) => {
    e.stopPropagation();

    const delta = isPlus ? 1 : -1;
    const callCount = currentCallCount + delta;

    //Don't want it under 0 or over 10
    if (callCount < -1 || callCount > 10) {
      return;
    }

    updateCallCount.mutate({ leadId: lead.id, delta }, {
      onSuccess: (response) => {
        const updatedLead = response.data;
        setCurrentCallCount(updatedLead.callCount);
        setCallCountUpdatedOn(updatedLead.callCountUpdatedOn);
        setCallCountUpdatedBy(updatedLead.callCountUpdatedBy);
        // saveHandlers.onSuccess();
      },
      onError: saveHandlers.onError
    });
  }

  return (
    <div className="flex items-center">

      <span className="flex flex-col items-center justify-center text-center w-24">
        <span className="">
          {currentCallCount === 10 ? ("Customer to call back") : 
          (
            currentCallCount === 0 ? ("Awaiting Call") : 
            currentCallCount === -1 ? ("Avoiding") :
            (`Called ${currentCallCount}`)
          )}
        </span>
        {(currentCallCount > 0 || currentCallCount === -1) && (
          <>
            <span className="text-xs">{callCountUpdatedOn && formatDateTime(callCountUpdatedOn, DateTime.DATETIME_SHORT)}</span>
            <span className="text-xs">{callCountUpdatedBy && <ContactFromId contactId={callCountUpdatedBy} />}</span>
          </>
        )}
      </span>

      <div className="flex flex-col ml-2">
        <button
          className="flex items-center justify-center w-6 h-6 text-lg font-bold rounded-full hover:bg-gray-200"
          onClick={(e) => handleCallListClick(e, true)}>+</button>
        <button
          className="flex items-center justify-center w-6 h-6 text-lg font-bold rounded-full hover:bg-gray-200"
          onClick={(e) => handleCallListClick(e, false)}>-</button>
      </div>
    </div>
  )
}
